var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditorBot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 36,
    viewBox: "0 0 34 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 16.5,
    r: 16.5,
    fill: "url(#paint0_linear_3423_15023)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ddi_3423_15023)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.0787 12.7757C23.0008 12.7757 22.9346 12.7597 22.8801 12.7279C22.8255 12.6961 22.7827 12.6404 22.7515 12.5609L22.0738 10.9379L20.3678 10.1742C20.2899 10.1424 20.2353 10.0986 20.2042 10.043C20.173 9.98727 20.1574 9.91965 20.1574 9.8401C20.1574 9.76054 20.173 9.69292 20.2042 9.63723C20.2353 9.58154 20.2899 9.53779 20.3678 9.50597L22.0738 8.76611L22.7515 7.2148C22.7827 7.13524 22.8255 7.07955 22.8801 7.04773C22.9346 7.01591 23.0008 7 23.0787 7C23.1566 7 23.2228 7.01591 23.2774 7.04773C23.3319 7.07955 23.3747 7.13524 23.4059 7.2148L24.0836 8.76611L25.7897 9.50597C25.8676 9.53779 25.9221 9.58154 25.9533 9.63723C25.9844 9.69292 26 9.76054 26 9.8401C26 9.91965 25.9844 9.98727 25.9533 10.043C25.9221 10.0986 25.8676 10.1424 25.7897 10.1742L24.0836 10.9379L23.4059 12.5609C23.3747 12.6404 23.3319 12.6961 23.2774 12.7279C23.2228 12.7597 23.1566 12.7757 23.0787 12.7757ZM23.0787 27C23.0164 27 22.9541 26.9841 22.8918 26.9523C22.8294 26.9204 22.7827 26.8648 22.7515 26.7852L22.0738 25.2339L20.3911 24.494C20.3132 24.4622 20.2587 24.4185 20.2276 24.3628C20.1964 24.3071 20.1808 24.2395 20.1808 24.1599C20.1808 24.0803 20.1964 24.0127 20.2276 23.957C20.2587 23.9014 20.3132 23.8576 20.3911 23.8258L22.0738 23.0859L22.7515 21.4391C22.7827 21.3596 22.8255 21.3039 22.8801 21.2721C22.9346 21.2403 23.0008 21.2243 23.0787 21.2243C23.1566 21.2243 23.2228 21.2403 23.2774 21.2721C23.3319 21.3039 23.3747 21.3596 23.4059 21.4391L24.0836 23.0859L25.7663 23.8258C25.8442 23.8576 25.8987 23.9014 25.9299 23.957C25.9611 24.0127 25.9766 24.0803 25.9766 24.1599C25.9766 24.2395 25.9611 24.3071 25.9299 24.3628C25.8987 24.4185 25.8442 24.4622 25.7663 24.494L24.0836 25.2339L23.4059 26.7852C23.3747 26.8648 23.328 26.9204 23.2657 26.9523C23.2034 26.9841 23.141 27 23.0787 27ZM12.8192 22.8711C12.6945 22.8711 12.5738 22.8353 12.4569 22.7637C12.3401 22.6921 12.2505 22.5927 12.1882 22.4654L10.6691 19.148L7.39729 17.6444C7.27265 17.5807 7.17528 17.4893 7.10517 17.3699C7.03506 17.2506 7 17.1273 7 17C7 16.8727 7.03506 16.7494 7.10517 16.6301C7.17528 16.5107 7.27265 16.4193 7.39729 16.3556L10.6691 14.852L12.1882 11.5585C12.2505 11.4153 12.3401 11.3079 12.4569 11.2363C12.5738 11.1647 12.6945 11.1289 12.8192 11.1289C12.9438 11.1289 13.0646 11.1647 13.1814 11.2363C13.2983 11.3079 13.3879 11.4073 13.4502 11.5346L14.9926 14.852L18.2411 16.3556C18.3813 16.4193 18.4865 16.5107 18.5566 16.6301C18.6267 16.7494 18.6617 16.8727 18.6617 17C18.6617 17.1273 18.6267 17.2506 18.5566 17.3699C18.4865 17.4893 18.3813 17.5807 18.2411 17.6444L14.9926 19.148L13.4502 22.4654C13.3879 22.6086 13.2983 22.712 13.1814 22.7757C13.0646 22.8393 12.9438 22.8711 12.8192 22.8711Z",
    fill: "url(#paint1_linear_3423_15023)",
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddi_3423_15023",
    x: 0.215413,
    y: 1.07323,
    width: 31.7893,
    height: 33.9591,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.40371,
    dy: 2.65145
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.69044
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0506089 0 0 0 0 0.0159861 0 0 0 0 0.191833 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3423_15023"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.32572,
    dy: -1.24774
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.33951
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_3423_15023",
    result: "effect2_dropShadow_3423_15023"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_3423_15023",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.27532
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.06657
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_3423_15023"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3423_15023",
    x1: 17.5,
    y1: 0,
    x2: 17.5,
    y2: 33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C85F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D4E91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3423_15023",
    x1: 19.8213,
    y1: 16.4141,
    x2: 16.7513,
    y2: 30.3744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.23
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditorBot);
export default __webpack_public_path__ + "static/media/EditorBot.a7d00a5ea83bd7d3e11636b22beafbc7.svg";
export { ForwardRef as ReactComponent };